module.exports = __webpack_public_path__ + "static/mp-a7458068a641a2bb7ed0c3aeb8073528.jpg";